import { colors } from '../../Colors/colors'

export const parameterStoreTheme = {
   light: {
      closeIconColor: colors['gray-500'],
      parameterHeader: {
         parameterHeaderBottomBorderColor: 'border-gray-300',
         parameterTextColor: 'text-gray-900',
         plusIconFillColor: colors['base-white'],
         searchIconColor: colors['gray-500']
      },
      parameterNoDataView: {
         plusIconFillColor: colors['base-white']
      },
      createParameter: {
         titleTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600'
      },
      parameterSidePane: {
         headerTitleTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500'],
         headerBorderBottomColor: 'border-gray-300',
         bodyBorderBottomColor: 'border-gray-200',
         deleteIconColor: colors['error-500'],
         deleteTextColor: 'text-red-600',
         titleTextColor: 'text-gray-900',
         deleteIconHoverColor: 'hover:bg-gray-50'
      }
   },
   dark: {}
}
